/* v2.65 bootstrap shim — Liquid injects the asset URLs */
(function () {
  if (!window.CUST_THEME_ASSET_BASE) window.CUST_THEME_ASSET_BASE = '';  // empty = same as default
})();
/* customization-page.js — bundled from prototype scripts/*.js */

/* === scripts/main.js === */
/* =========================================================================
   main.js — Customization Page bootstrap.
   - Loads partials (v2.5 header + footer HTML) via fetch
   - Loads all data/*.json files
   - Exposes window.CustPage with { data, modal, banner, on }
   - Fires 'cust-page-ready' event when partials + data are ready
   - All other modules listen for cust-page-ready then bootstrap themselves
   ========================================================================= */
(function () {
  'use strict';

  var DATA_FILES = [
    'journey-steps',
    'features',
    'process',
    'case-studies',
    'faq',
    'pdfs',
    'wizard-sample-data'
  ];

  var PARTIALS = {
    header: 'partials/header.html',
    footer: 'partials/footer.html'
  };

  var DATA = {};
  var PARTIAL_HTML = {};

  // -------- Helpers --------
  function fetchText(path) {
    return fetch(path).then(function (r) {
      if (!r.ok) throw new Error('Failed to fetch ' + path + ' (' + r.status + ')');
      return r.text();
    });
  }
  function fetchJson(path) {
    return fetch(path).then(function (r) {
      if (!r.ok) throw new Error('Failed to fetch ' + path + ' (' + r.status + ')');
      return r.json();
    });
  }

  // -------- Partial loading --------
  function loadPartials() {
    // v2.65: theme.liquid layout provides header/footer — no fetch needed.
    return Promise.resolve();
  }

  // -------- Data loading --------
  function loadData() {
    // v2.65: data comes from inline <script id="cust-page-data"> blob (no network).
    var el = document.getElementById('cust-page-data');
    if (!el) return Promise.reject(new Error('cust-page-data blob missing'));
    try {
      var blob = JSON.parse(el.textContent);
      Object.keys(blob).forEach(function (k) {
        if (k.charAt(0) !== '_') DATA[k] = blob[k];
      });
      return Promise.resolve();
    } catch (e) {
      console.error('[CustPage] parse blob failed:', e);
      return Promise.reject(e);
    }
  }

  // -------- Modal API (shared by all modal types) --------
  var modalEl = null;
  var modalContent = null;
  var modalBack = null;
  var lastTrigger = null;
  var backStack = [];  // history of content keys for back-button support

  function openModal(html, opts) {
    opts = opts || {};
    if (!modalEl) modalEl = document.querySelector('[data-cust-modal]');
    if (!modalContent) modalContent = modalEl.querySelector('[data-cust-modal-content]');
    if (!modalBack) modalBack = modalEl.querySelector('[data-cust-modal-back]');

    modalContent.innerHTML = html;
    // Back button was removed from the DOM per A 2026-06-08; null-check so the
    // entire modal system doesn't TypeError on every open.
    if (modalBack) {
      modalBack.hidden = !(opts.showBack && backStack.length > 0);
    }
    modalEl.hidden = false;
    requestAnimationFrame(function () { modalEl.setAttribute('data-open', ''); });
    // Compensate for the scrollbar width disappearing under overflow:hidden so the
    // page doesn't reflow wider behind the modal (measured live).
    var cpScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (cpScrollbarWidth > 0) document.body.style.paddingRight = cpScrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';
    if (opts.trigger) lastTrigger = opts.trigger;
  }

  function pushModal(html, opts) {
    // Push current content onto stack, then open new content
    if (modalContent && modalContent.innerHTML) {
      backStack.push({ html: modalContent.innerHTML });
    }
    openModal(html, Object.assign({ showBack: true }, opts || {}));
  }

  function popModal() {
    var prev = backStack.pop();
    if (prev) {
      openModal(prev.html, { showBack: backStack.length > 0 });
    } else {
      closeModal();
    }
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.removeAttribute('data-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    setTimeout(function () {
      modalEl.hidden = true;
      modalContent.innerHTML = '';
      backStack = [];
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }, 240);
  }

  function wireModalControls() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cust-modal-close]')) {
        closeModal();
      }
      if (e.target.closest('[data-cust-modal-back]')) {
        popModal();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl && !modalEl.hidden) {
        closeModal();
      }
    });
  }

  // -------- Toast banner --------
  var bannerTimer = null;
  function flashBanner(message, durationMs) {
    durationMs = durationMs || 2500;
    var el = document.querySelector('[data-cust-banner]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(bannerTimer);
    bannerTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, durationMs);
  }

  // -------- Contact form: AJAX submit + inline validation --------
  // A 2026-06-08: form submits in-place without a URL reload. Required fields
  // get red borders + inline error text on blur or on submit attempt. Submit
  // POSTs to Shopify's /contact endpoint via fetch and displays a success or
  // error state inline.
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // a11y 1c (2026-10-21): an error is tied to its control (aria-invalid + aria-describedby), so a screen reader
  // reads it when the control takes focus; before, only the red border and the line below said so.
  function clearFieldError(field) {
    field.classList.remove('has-error');
    var msg = field.querySelector('.cust-form__field-error');
    if (msg) msg.remove();
    var input = field.querySelector('input, textarea');
    if (input) { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); }
  }
  function setFieldError(field, text) {
    field.classList.add('has-error');
    var msg = field.querySelector('.cust-form__field-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cust-form__field-error';
      field.appendChild(msg);
    }
    msg.textContent = text;
    var input = field.querySelector('input, textarea');
    if (input) {
      msg.id = input.id + '-error';
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', msg.id);
    }
  }
  function validateField(input) {
    var field = input.closest('.cust-form__field');
    if (!field) return true;
    var val = (input.value || '').trim();
    if (input.required && !val) {
      setFieldError(field, 'This field is required.');
      return false;
    }
    if (input.type === 'email' && val && !EMAIL_RX.test(val)) {
      setFieldError(field, 'Enter a valid email address.');
      return false;
    }
    clearFieldError(field);
    return true;
  }

  function showFormBanner(form, kind, html) {
    var existing = form.querySelector('.cust-form__banner');
    if (existing) existing.remove();
    var b = document.createElement('div');
    b.className = 'cust-form__banner cust-form__banner--' + kind;
    b.setAttribute('role', kind === 'error' ? 'alert' : 'status');
    b.innerHTML = html;
    var intro = form.querySelector('.cust-form__intro');
    if (intro && intro.nextSibling) {
      form.insertBefore(b, intro.nextSibling);
    } else {
      form.insertBefore(b, form.firstChild);
    }
    // a11y 1c (2026-10-21): the result takes focus. A live region added with its text already in is often not read,
    // and focus was on the submit button, which is disabled while sending.
    b.setAttribute('tabindex', '-1');
    b.focus();
    return b;
  }

  function submitContactForm(form) {
    var btn = form.querySelector('.cust-form__submit');
    var origLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    var data = new FormData(form);
    fetch('/contact', { method: 'POST', body: data, credentials: 'same-origin' })
      .then(function (res) {
        // Shopify redirects on both success + error. We detect success by
        // checking the response URL for the standard posted_successfully query.
        var url = res.url || '';
        var ok = res.ok && (url.indexOf('contact_posted=true') !== -1 ||
                            url.indexOf('posted_successfully') !== -1 ||
                            url.indexOf('?customer_posted=true') !== -1);
        if (ok) {
          form.querySelectorAll('.cust-form__field input, .cust-form__field textarea')
              .forEach(function (i) { i.value = ''; clearFieldError(i.closest('.cust-form__field')); });
          showFormBanner(form, 'success', '<p>Thanks. We received your question and will get back to you the same business day.</p>');
        } else {
          // Try to parse the response body for Shopify's standard error messages.
          return res.text().then(function (text) {
            var msg = 'There was a problem submitting your message. Please check your details and try again.';
            // Most common error: invalid email — surface that explicitly.
            if (/email[^<]*invalid/i.test(text)) msg = 'Please enter a valid email address.';
            showFormBanner(form, 'error', '<p>' + msg + '</p>');
          });
        }
      })
      .catch(function () {
        showFormBanner(form, 'error', '<p>We couldn\'t reach the server. Check your connection and try again.</p>');
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
      });
  }

  // A 2026-06-08 (round 3): hardened wireup.
  // Earlier wireContactForm relied on form being in the DOM at boot time. If
  // boot's Promise.all rejects (e.g. blob parse error on a stale theme), the
  // submit listener never attaches and the browser native-submits with a
  // page reload. Switch to document-level capture-phase delegation that fires
  // even if init order goes sideways. Capture phase guarantees we preempt any
  // other bubble-phase submit handlers. Re-callable — first call wires the
  // document listener, later calls only re-wire field validation.
  var _docSubmitWired = false;
  function wireContactForm() {
    if (!_docSubmitWired) {
      _docSubmitWired = true;
      document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== 'cust-contact-form') return;
      e.preventDefault();
      e.stopPropagation();
      var inputs = form.querySelectorAll('.cust-form__field input, .cust-form__field textarea');
      var allValid = true;
      var firstInvalid = null;
      inputs.forEach(function (input) {
        var ok = validateField(input);
        if (!ok && !firstInvalid) firstInvalid = input;
        if (!ok) allValid = false;
      });
      if (!allValid) {
        if (firstInvalid) firstInvalid.focus();
        return;
      }
      submitContactForm(form);
    }, true /* capture phase */);
    }

    // Best-effort per-field on-blur validation. Runs only if the form is in
    // the DOM at wireup time; harmless if not.
    var form = document.getElementById('cust-contact-form');
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      var inputs = form.querySelectorAll('.cust-form__field input, .cust-form__field textarea');
      inputs.forEach(function (input) {
        input.addEventListener('blur', function () { validateField(input); });
        input.addEventListener('input', function () {
          var field = input.closest('.cust-form__field');
          if (field && field.classList.contains('has-error')) clearFieldError(field);
          var banner = form.querySelector('.cust-form__banner--error');
          if (banner) banner.remove();
        });
      });
    }
  }

  // -------- FAQ render (zero-JS friendly but we inject content) --------
  function renderFaq() {
    var container = document.querySelector('[data-cust-faq]');
    if (!container || !DATA.faq) return;
    var items = DATA.faq.items || [];
    container.innerHTML = items.map(function (item) {
      // Answer is escaped; if the item has a `links` map, wrap the first occurrence
      // of each keyed phrase in an anchor (injected after escaping, so it's safe).
      var answerHtml = escapeHtml(item.a);
      var links = item.links || {};
      Object.keys(links).forEach(function (phrase) {
        var def = links[phrase];
        if (!def || !def.href) return;
        var a = '<a href="' + escapeHtml(def.href) + '"' + (def.newTab ? ' target="_blank" rel="noopener"' : '') + '>' + escapeHtml(phrase) + '</a>';
        answerHtml = answerHtml.replace(escapeHtml(phrase), function () { return a; });
      });
      return (
        '<details>' +
          '<summary>' +
            '<span>' + escapeHtml(item.q) + '</span>' +
            '<svg class="cust-faq-caret" width="12" height="12" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>' +
          '</summary>' +
          '<div class="cust-faq__answer">' + answerHtml + '</div>' +
        '</details>'
      );
    }).join('');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // -------- Boot --------
  function boot() {
    wireModalControls();
    // Wire the contact form FIRST and outside the Promise chain so a bad
    // data-blob (which would reject loadData) can't strand the form in
    // page-reload mode. The handler is a document-level capture listener,
    // doesn't need the form to be in the DOM yet.
    wireContactForm();
    return Promise.all([loadPartials(), loadData()]).then(function () {
      renderFaq();
      wireContactForm();
      // Expose API for module scripts
      window.CustPage = {
        data: DATA,
        partials: PARTIAL_HTML,
        modal: {
          open: openModal,
          push: pushModal,
          pop: popModal,
          close: closeModal
        },
        flashBanner: flashBanner,
        escapeHtml: escapeHtml
      };
      document.dispatchEvent(new CustomEvent('cust-page-ready'));
      console.log('[CustPage] Ready. Data:', DATA);
    }).catch(function (err) {
      console.error('[CustPage] Boot failed:', err);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* === scripts/hero-rotator.js === */
/* =========================================================================
   hero-rotator.js — Hero 4-step bullet list.
   All items rendered fully expanded; no auto-advance, no transitions, no interactivity.
   ========================================================================= */
(function () {
  'use strict';

  function render(items_data) {
    var rotator = document.querySelector('[data-cust-rotator]');
    if (!rotator) return;
    // Card pattern ported from the live warranty page's .ag-wty-card structure (image-slot
    // dropped per A's 2026-06-05 direction; text-only now). Mapping kept for reference:
    //   .cust-rotator-inner   = ag-wty-card-inner (padded body)
    //   .cust-rotator-top     = ag-wty-card-top (label + big num row)
    //   .cust-rotator-num     = navy number circle (Datch 2026-06-16; "Step" label removed)
    //   .cust-rotator-title   = step title, sits to the RIGHT of the number circle
    //   .cust-rotator-desc    = ag-wty-card-body
    rotator.innerHTML = items_data.map(function (it) {
      var descHtml = window.CustPage.escapeHtml(it.desc);
      // Linkify words in the description per the step's `links` map (escape the desc
      // first, inject anchors/buttons after, so the rest of the text stays safe). Each
      // entry is keyed by the word; one of:
      //   { modal: "existing" | "scratch" }   -> button that opens the entry modal
      //   { mailto: "addr" }                   -> mailto: link
      //   { href: "url", newTab: true }        -> normal link (newTab optional)
      var links = it.links || {};
      Object.keys(links).forEach(function (word) {
        var def = links[word], esc = window.CustPage.escapeHtml, html;
        if (def.modal) {
          html = '<button type="button" class="cust-rotator-link" data-cust-trigger="entry-selector" data-cust-entry-path="' + esc(def.modal) + '">' + esc(word) + '</button>';
        } else if (def.mailto) {
          html = '<a class="cust-rotator-link" href="mailto:' + esc(def.mailto) + '">' + esc(word) + '</a>';
        } else if (def.href) {
          html = '<a class="cust-rotator-link" href="' + esc(def.href) + '"' + (def.newTab ? ' target="_blank" rel="noopener noreferrer"' : '') + '>' + esc(word) + '</a>';
        } else { return; }
        descHtml = descHtml.replace(new RegExp('\\b' + word + '\\b'), function () { return html; });
      });
      return (
        '<li class="cust-rotator-item">' +
          '<div class="cust-rotator-inner">' +
            '<div class="cust-rotator-top">' +
              '<span class="cust-rotator-num">' + window.CustPage.escapeHtml(it.num) + '</span>' +
              '<h3 class="cust-rotator-title">' + window.CustPage.escapeHtml(it.title) + '</h3>' +
            '</div>' +
            '<p class="cust-rotator-desc">' + descHtml + '</p>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function init() {
    var page = window.CustPage;
    if (!page || !page.data || !page.data['journey-steps']) return;
    var data = page.data['journey-steps'];
    render(data.items || []);
  }

  document.addEventListener('cust-page-ready', init);
})();


/* === scripts/pdf-tile.js === */
/* =========================================================================
   pdf-tile.js — CAD PDF carousel + viewer.
   - Renders all PDFs as horizontal-scroll carousel cards in the
     "See us in action" section. Each card shows a PDF.js-rendered
     first-page thumbnail + the document label below.
   - Click any card → opens the full viewer modal (all pages stacked,
     prev/next document buttons).
   ========================================================================= */
(function () {
  'use strict';

  var pdfs = []; // [{ file, label, category, doc }]

  // If the build pipeline has already swapped `file` for an absolute Shopify CDN
  // URL (build_v265_section.py rewrite_pdfs), pass it through. Otherwise treat
  // it as a local filename relative to assets/pdfs/.
  function pdfPath(file) {
    if (/^https?:\/\//.test(file) || file.charAt(0) === '/') return file;
    return 'assets/pdfs/' + file;
  }

  function loadPdf(file) {
    if (!window.pdfjsLib) return Promise.reject(new Error('PDF.js not loaded'));
    return window.pdfjsLib.getDocument(pdfPath(file)).promise;
  }

  function renderFirstPageToCanvas(doc, canvasContainer, opts) {
    opts = opts || {};
    return doc.getPage(1).then(function (page) {
      var unscaledViewport = page.getViewport({ scale: 1 });
      // Aspect-match the container to the PDF so portrait/landscape PDFs both fill cleanly.
      canvasContainer.style.aspectRatio = unscaledViewport.width + ' / ' + unscaledViewport.height;
      void canvasContainer.offsetHeight; // force layout
      var containerW = canvasContainer.clientWidth || 280;
      var scale = (containerW / unscaledViewport.width) * (opts.scaleMul || 1);
      var viewport = page.getViewport({ scale: scale });
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvasContainer.innerHTML = '';
      canvasContainer.appendChild(canvas);
      return page.render({ canvasContext: ctx, viewport: viewport }).promise;
    });
  }

  function renderPageToCanvas(doc, pageNum, canvasContainer) {
    return doc.getPage(pageNum).then(function (page) {
      var containerW = canvasContainer.clientWidth;
      if (!containerW || containerW < 50) {
        var fallback = canvasContainer.parentElement;
        containerW = (fallback ? fallback.clientWidth - 80 : 0) || 720;
      }
      var unscaledViewport = page.getViewport({ scale: 1 });
      var scale = containerW / unscaledViewport.width;
      var viewport = page.getViewport({ scale: scale });
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvasContainer.innerHTML = '';
      canvasContainer.appendChild(canvas);
      return page.render({ canvasContext: ctx, viewport: viewport }).promise;
    });
  }

  // -------- Single-PDF viewer modal (all pages stacked, vertical scroll) --------
  // Per A 2026-06-05: prev/next document footer buttons removed. Header now also
  // shows the description of what was customized + a link to the product page.
  function openViewer(startIdx) {
    var page = window.CustPage;
    var entry = pdfs[startIdx];
    if (!entry) return;

    var page_esc = page.escapeHtml;
    var descHtml = entry.description
      ? '<p class="cust-pdf-viewer__desc">Project summary: ' + page_esc(entry.description) + '</p>'
      : '';
    var linkHtml = entry.product_url
      ? '<a class="cust-pdf-viewer__link" href="' + page_esc(entry.product_url) + '" target="_blank" rel="noopener">View original model design &rarr;</a>'
      : '';
    var html =
      '<div class="cust-pdf-viewer">' +
        '<div class="cust-pdf-viewer__header">' +
          '<div class="cust-eyebrow">' +
            '<svg class="cust-eyebrow-cust-icon" viewBox="0 0 720 720" fill="none" stroke="currentColor" stroke-width="50" stroke-miterlimit="10" aria-hidden="true">' +
              '<polygon points="138.9 83.75 138.9 589.78 639.67 583.21 138.9 83.75"></polygon>' +
              '<polygon points="224.33 283.53 224.33 512.23 455.66 512.23 224.33 283.53"></polygon>' +
              '<line x1="245.36" y1="251.99" x2="277.08" y2="221.58"></line>' +
              '<line x1="300.56" y1="305.88" x2="331.04" y2="275.39"></line>' +
              '<line x1="359.71" y1="355.35" x2="385" y2="329.21"></line>' +
              '<line x1="417.54" y1="407.08" x2="438.31" y2="382.38"></line>' +
              '<line x1="474.06" y1="463.6" x2="495.55" y2="439.47"></line>' +
              '<line x1="530.58" y1="512.23" x2="550.83" y2="494.6"></line>' +
            '</svg>Customization project</div>' +
          '<h2 class="cust-modal__h2">' + page_esc(entry.label) + '</h2>' +
          '<div class="cust-pdf-viewer__meta">' + descHtml + linkHtml + '</div>' +
        '</div>' +
        '<div class="cust-pdf-viewer__stage">' +
          '<div class="cust-pdf-viewer__pages" data-pdf-viewer-pages></div>' +
        '</div>' +
      '</div>';
    page.modal.open(html);

    var pagesContainer = document.querySelector('[data-pdf-viewer-pages]');

    function renderAllPages(doc) {
      pagesContainer.innerHTML = '';
      var total = doc.numPages;
      for (var i = 1; i <= total; i++) {
        (function (pageNum) {
          var wrap = document.createElement('div');
          wrap.className = 'cust-pdf-viewer__page';
          var canvasHost = document.createElement('div');
          canvasHost.className = 'cust-pdf-viewer__page-canvas';
          var label = document.createElement('div');
          label.className = 'cust-pdf-viewer__page-label';
          label.textContent = pageNum + ' / ' + total;
          wrap.appendChild(canvasHost);
          wrap.appendChild(label);
          pagesContainer.appendChild(wrap);
          renderPageToCanvas(doc, pageNum, canvasHost);
        })(i);
      }
    }

    if (!entry.doc) {
      loadPdf(entry.file).then(function (doc) {
        entry.doc = doc;
        renderAllPages(doc);
      });
    } else {
      renderAllPages(entry.doc);
    }
  }

  // -------- Carousel render --------
  // Per A 2026-06-05: card now has description + product link below the meta
  // header. Card is no longer a single <button> (would nest <a> illegally) —
  // restructured as <article> containing a thumb-opener <button> + a meta block
  // with category / label / description / product <a>.
  function renderCarousel() {
    var page = window.CustPage;
    var container = document.querySelector('[data-cust-pdf-carousel]');
    if (!container) return;

    var itemsHtml = pdfs.map(function (entry, i) {
      var descHtml = entry.description
        ? '<p class="cust-pdf-carousel__desc">' + page.escapeHtml(entry.description) + '</p>'
        : '';
      // A 2026-06-08: replace the previous "View product →" link with a
      // "View more →" affordance styled like the case-study cards (cust-card--text__more).
      // Click opens the PDF viewer modal (same as thumb/label).
      var moreHtml =
        '<button class="cust-pdf-carousel__more cust-card--text__more" type="button" data-pdf-carousel-idx="' + i + '">' +
          'View project <span aria-hidden="true">&rarr;</span>' +
        '</button>';
      return (
        '<article class="cust-pdf-carousel__item">' +
          '<button class="cust-pdf-carousel__opener" data-pdf-carousel-idx="' + i + '" type="button" aria-label="View ' + page.escapeHtml(entry.label) + ' CAD">' +
            '<div class="cust-pdf-carousel__thumb" data-pdf-carousel-thumb="' + i + '"></div>' +
          '</button>' +
          '<div class="cust-pdf-carousel__meta">' +
            '<div class="cust-pdf-carousel__header">' +
              '<span class="cust-pdf-carousel__category">' + page.escapeHtml(entry.category || '') + '</span>' +
              '<button class="cust-pdf-carousel__label" data-pdf-carousel-idx="' + i + '" type="button">' + page.escapeHtml(entry.label) + '</button>' +
            '</div>' +
            descHtml +
            moreHtml +
          '</div>' +
        '</article>'
      );
    }).join('');

    // A 2026-06-09: wrap items in a track + add prev/next arrows that swipe
    // the carousel. Container becomes a flex wrapper (arrow / track / arrow).
    // Arrow shape + size + positioning copied from .cust-cv-carousel__arrow
    // (case-study viewer modal) — same visual language across both carousels.
    container.classList.add('cust-pdf-carousel--with-arrows');
    container.innerHTML =
      '<button type="button" class="cust-pdf-carousel__arrow cust-pdf-carousel__arrow--prev" data-cust-pdf-prev aria-label="Previous" hidden>' +
        '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M165.66 202.34a8 8 0 0 1-11.32 11.32l-80-80a8 8 0 0 1 0-11.32l80-80a8 8 0 0 1 11.32 11.32L91.31 128Z"/></svg>' +
      '</button>' +
      '<div class="cust-pdf-carousel__track" data-cust-pdf-track>' + itemsHtml + '</div>' +
      '<button type="button" class="cust-pdf-carousel__arrow cust-pdf-carousel__arrow--next" data-cust-pdf-next aria-label="Next">' +
        '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M181.66 133.66l-80 80a8 8 0 0 1-11.32-11.32L164.69 128 90.34 53.66a8 8 0 0 1 11.32-11.32l80 80A8 8 0 0 1 181.66 133.66Z"/></svg>' +
      '</button>';

    var track = container.querySelector('[data-cust-pdf-track]');
    var prevBtn = container.querySelector('[data-cust-pdf-prev]');
    var nextBtn = container.querySelector('[data-cust-pdf-next]');

    function step(dir) {
      if (!track) return;
      // Snap to roughly one card width per click (matches the grid track width).
      var first = track.querySelector('.cust-pdf-carousel__item');
      var cardW = first ? first.getBoundingClientRect().width + 20 /* gap */ : Math.round(track.clientWidth * 0.75);
      track.scrollBy({ left: dir * cardW, behavior: 'smooth' });
    }
    function updateArrows() {
      if (!track) return;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (prevBtn) prevBtn.hidden = atStart;
      if (nextBtn) nextBtn.hidden = atEnd;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    var raf = null;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; updateArrows(); });
    }
    if (track) {
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      // Initial measure after layout settles + after thumbnails render.
      setTimeout(updateArrows, 50);
      setTimeout(updateArrows, 500);
    }

    // Paint each thumbnail = fetch its PDF + render the first page to canvas.
    // DEFERRED until the carousel nears the viewport (Datch 2026-06-18 perf): this loop
    // was fetching ~3.3MB of PDFs + a ~376ms PDF.js render on initial page load, for a
    // below-fold section many visitors never reach. rootMargin starts the work ~one
    // screen early so thumbs are ready before the user arrives (thumb reserves space via
    // aspect-ratio, so no visible shift). Falls back to immediate paint without IO.
    function paintThumbnails() {
      pdfs.forEach(function (entry, i) {
        var thumb = document.querySelector('[data-pdf-carousel-thumb="' + i + '"]');
        if (!thumb) return;
        function paint(doc) {
          if (!document.body.contains(thumb)) return;
          renderFirstPageToCanvas(doc, thumb);
        }
        if (entry.doc) {
          paint(entry.doc);
        } else {
          loadPdf(entry.file).then(function (doc) {
            entry.doc = doc;
            paint(doc);
          }).catch(function (err) {
            thumb.innerHTML = '<div class="cust-pdf-carousel__fallback">Unavailable</div>';
            console.warn('[pdf-carousel]', err);
          });
        }
      });
    }
    if ('IntersectionObserver' in window) {
      var thumbIO = new IntersectionObserver(function (entries, obs) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) { obs.disconnect(); paintThumbnails(); break; }
        }
      }, { rootMargin: '800px 0px' });
      thumbIO.observe(container);
    } else {
      paintThumbnails();
    }

    // Wire thumb-opener + label click → open viewer modal. Product link
    // handles its own navigation as a native <a target="_blank">.
    container.querySelectorAll('[data-pdf-carousel-idx]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-pdf-carousel-idx'), 10);
        openViewer(idx);
      });
    });
  }

  function init() {
    var page = window.CustPage;
    if (!page || !page.data || !page.data.pdfs) return;
    var data = page.data.pdfs;
    pdfs = (data.items || []).map(function (it) { return Object.assign({}, it, { doc: null }); });
    if (!pdfs.length) return;

    if (!window.pdfjsLib) {
      console.warn('[pdf-carousel] PDF.js not loaded');
      return;
    }
    renderCarousel();
  }

  document.addEventListener('cust-page-ready', init);
})();


/* === scripts/feature-modal.js === */
/* =========================================================================
   feature-modal.js — "Here's what's possible." inline feature rows
   (the explainer-modal click path is dormant; helpers retained).
   Each feature row picks a render layout via modal.format:
   - "ranges"        → per-category dimension chart (W × D × H)
   - "swatches"      → 4-col finish grid (color block + name + code)
   - "feature-rows"  → accordion capability list, each row with grouped sub-items
   - "chip-groups"   → flat labeled chip lists, no accordion (Branding row)
   - "bullets"       → fallback bulleted list
   ========================================================================= */
(function () {
  'use strict';

  // -------- Inline render (expanded per-feature rows, no modal click) --------
  // Per A's 2026-06-05 direction: each feature expands inline as an alternating
  // text + content row. CSS handles the L/R alternation via :nth-child(even).
  // Reuses the existing renderRangesBody / renderSwatchesBody / renderFeatureRowsBody /
  // renderBulletsBody functions — the modal click path is no longer used for these
  // features, but the rendering helpers stay.
  function renderInline(items) {
    var container = document.querySelector('[data-cust-features-grid]');
    if (!container) return;
    container.innerHTML = items.map(function (it) {
      var modal = it.modal || {};
      var contentHtml = renderBody(modal);
      // Branding row: example logo on the LEFT, technique/placement lists on the
      // RIGHT styled like Cable Management's column lists (Datch 2026-06-16).
      // renderSubColumns gives the titled bullet-list columns + divider; the
      // lists wrapper is its own query container so the columns size to the
      // space beside the logo. URL injected by Liquid (theme-asset, resized).
      if (it.id === 'branding') {
        var brandLogo = window.CUST_BRANDING_LOGO
          ? '<img class="cust-branding-logo" src="' + escape(window.CUST_BRANDING_LOGO) + '" alt="Example custom logo" loading="lazy" decoding="async">'
          : '';
        // Pantone block (Datch 2026-06-16, matching Datch's example): a narrow
        // caption (header + sentence) on the LEFT, and the fan-deck photo LARGE
        // at the top-right, bleeding off the section's right edge.
        var pantoneBlock = window.CUST_BRANDING_PANTONE
          ? '<div class="cust-branding-pantone">' +
              '<div class="cust-branding-pantone__cap">' +
                '<div class="cust-feat-col__title">Pantone&reg; color matching</div>' +
                '<p class="cust-branding-pantone-text">When brand colors are essential, Pantone is the world&rsquo;s standard for precise color matching.</p>' +
              '</div>' +
              '<span class="cust-branding-pantone__fan"><img src="' + escape(window.CUST_BRANDING_PANTONE) + '" alt="Pantone color-matching fan deck" loading="lazy" decoding="async"></span>' +
            '</div>'
          : '';
        contentHtml =
          '<div class="cust-branding-layout">' +
            brandLogo +
            '<div class="cust-branding-lists">' + renderSubColumns(modal.groups || []) + '</div>' +
            pantoneBlock +
          '</div>';
      }
      // Finishes carries the Download Finish Catalogue link (was modal footer link).
      var extras = '';
      if (it.id === 'finishes') {
        extras = (
          '<p class="cust-feature-row__extra">' +
            '<a class="cust-feature-row__catalogue-link" ' +
              'href="https://cdn.shopify.com/s/files/1/0600/0659/6668/files/Arc_Grove-Custom_Finishing_Selection_Guide.pdf" ' +
              'target="_blank" rel="noopener">Download Finish Catalogue' +
              '<span class="cust-visually-hidden"> (PDF, opens in new tab)</span>' +
              '<svg class="cust-feature-row__catalogue-arrow" width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg></a>' +
          '</p>'
        );
      }
      // PANTONE row (pms): the catalogue link opens at its PANTONE pages, then the
      // trademark line.
      if (it.id === 'pantone' && modal.link) {
        extras = (
          '<p class="cust-feature-row__extra">' +
            '<a class="cust-feature-row__catalogue-link" href="' + escape(modal.link.href) + '" target="_blank" rel="noopener">' +
              escape(modal.link.label) +
              '<span class="cust-visually-hidden"> (PDF, opens in new tab)</span>' +
              '<svg class="cust-feature-row__catalogue-arrow" width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg></a>' +
          '</p>' +
          (modal.legal ? '<p class="cust-pms-legal">' + escape(modal.legal) + '</p>' : '')
        );
      }
      var intro = modal.intro || it.desc || '';
      return (
        '<div class="cust-feature-row" data-cust-feature-row="' + escape(it.id) + '">' +
          '<div class="cust-feature-row__text">' +
            (it.eyebrow ? '<span class="cust-feature-row__eyebrow">' + escape(it.eyebrow) + '</span>' : '') +
            '<h3 class="cust-feature-row__title">' + escape(it.title) + '</h3>' +
            '<p class="cust-feature-row__intro">' + escape(intro) + '</p>' +
            extras +
          '</div>' +
          '<div class="cust-feature-row__content">' +
            contentHtml +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function escape(s) { return window.CustPage.escapeHtml(s); }

  // Split "1600–3000 mm (63–118 in)" into { metric: "1600–3000 mm",
  // imperial: "63–118 in" } so each cell can stack the two units. Falls back to
  // the raw string if the pattern doesn't match.
  function splitDimValue(s) {
    if (!s || s === '—') return { metric: s || '—', imperial: '' };
    var m = s.match(/^([^(]+?)\s*\(([^)]+)\)\s*$/);
    if (!m) return { metric: s, imperial: '' };
    return { metric: m[1].trim(), imperial: m[2].trim() };
  }
  // Imperial on top (primary), metric below (secondary) — Datch 2026-06-12.
  function renderDimCell(s) {
    var p = splitDimValue(s);
    if (!p.imperial) return '<td><span class="cust-dim-table__primary">' + escape(p.metric) + '</span></td>';
    return (
      '<td>' +
        '<span class="cust-dim-table__primary">' + escape(p.imperial) + '</span>' +
        '<span class="cust-dim-table__secondary">' + escape(p.metric) + '</span>' +
      '</td>'
    );
  }
  // Transposed (Datch 2026-06-12): categories across the header,
  // Width / Depth / Height as the body rows.
  function renderRangesBody(modal) {
    var cats = modal.categories || [];
    var dims = [
      { key: 'width',  label: 'Width' },
      { key: 'depth',  label: 'Depth' },
      { key: 'height', label: 'Height' }
    ];
    var headHtml = cats.map(function (c) {
      return '<th>' + escape(c.name) + '</th>';
    }).join('');
    var rowsHtml = dims.map(function (d) {
      var cells = cats.map(function (c) { return renderDimCell(c[d.key]); }).join('');
      return (
        '<tr>' +
          '<th class="cust-dim-table__cat">' + escape(d.label) + '</th>' +
          cells +
        '</tr>'
      );
    }).join('');
    return (
      // Scroll wrapper: 5 transposed columns overflow phone widths; the
      // wrapper only scrolls when the table is wider than its container.
      // a11y 1a (2026-10-20): focusable + named so keyboard users can scroll it (WCAG 2.1.1, axe scrollable-region-focusable)
      '<div class="cust-dim-scroll" tabindex="0" role="region" aria-label="Dimensions by product type">' +
        '<table class="cust-dim-table">' +
          '<thead><tr>' +
            '<th class="cust-dim-table__title" aria-hidden="true"></th>' +
            headHtml +
          '</tr></thead>' +
          '<tbody>' + rowsHtml + '</tbody>' +
        '</table>' +
      '</div>'
    );
  }

  var FAMILY_ORDER = ['Solid', 'Marble', 'Other', 'Woodgrain'];
  var TONE_ORDER = ['Light', 'Medium', 'Dark'];

  // Shopify CDN: append &width=N for an on-the-fly resized variant.
  // Chip displays ~140-180px wide @ 2x DPR -> request 360px, plenty of headroom
  // and ~12-20x smaller than the 1600px master.
  function resizedCdn(url, width) {
    if (!url) return '';
    if (/cdn\.shopify\.com/.test(url)) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'width=' + width;
    }
    return url;
  }

  // Family -> tone -> name order (the old default grouping order, flattened)
  // so related finishes sit together in the field.
  function sortFamilyTone(swatches) {
    var fi = {};
    FAMILY_ORDER.forEach(function (v, i) { fi[v] = i; });
    var ti = {};
    TONE_ORDER.forEach(function (v, i) { ti[v] = i; });
    return swatches.slice().sort(function (a, b) {
      var af = fi[a.family] == null ? 99 : fi[a.family];
      var bf = fi[b.family] == null ? 99 : fi[b.family];
      if (af !== bf) return af - bf;
      // aglv1 (2026-08-16, A): within a family, carried-over finishes
      // sort before the 2026 LS26 set.
      var a26 = /^LS26/.test(a.code || '') ? 1 : 0;
      var b26 = /^LS26/.test(b.code || '') ? 1 : 0;
      if (a26 !== b26) return a26 - b26;
      var at = ti[a.tone] == null ? 99 : ti[a.tone];
      var bt = ti[b.tone] == null ? 99 : ti[b.tone];
      if (at !== bt) return at - bt;
      return (a.name || '').localeCompare(b.name || '');
    });
  }

  // Finishes redesign (Datch 2026-06-12): flat field of circular swatches,
  // 20 per row on desktop, no visible names/codes. Hover or keyboard focus
  // raises a card with the larger finish image + name + code. The filter/sort
  // controls and family grouping are gone (the request form does that work).
  function renderSwatchesBody(modal) {
    var swatches = sortFamilyTone(modal.swatches || []);
    var dots = swatches.map(function (s) {
      var face = s.image
        ? '<span class="cust-finish-dot__face" style="background-image:url(' + escape(resizedCdn(s.image, 96)) + ')"></span>'
        : '<span class="cust-finish-dot__face" style="background:' + escape(s.color || '#ccc') + ';"></span>';
      var cardImg = s.image
        ? '<img class="cust-finish-dot__card-img" loading="lazy" decoding="async" src="' + escape(resizedCdn(s.image, 360)) + '" alt="">'
        : '<span class="cust-finish-dot__card-img" style="background:' + escape(s.color || '#ccc') + ';"></span>';
      // Rich detail card (mirrors the PDP finish-card-panel: square swatch LEFT,
      // text RIGHT; eyebrow -> name -> divider -> per-finish description ->
      // Texture / Material / Code). Tone pill removed per Datch 2026-06-26.
      // desc/texture/material come pre-resolved from the finishing metaobjects
      // (tools/enrich-cust-finishes.mjs); texture is blank for "Other" -> row suppressed.
      function specRow(label, val) {
        return val
          ? '<span class="cust-finish-dot__card-spec">' +
              '<span class="cust-finish-dot__card-label">' + escape(label) + '</span>' +
              '<span class="cust-finish-dot__card-val">' + escape(val) + '</span>' +
            '</span>'
          : '';
      }
      return (
        '<button type="button" class="cust-finish-dot" aria-label="' + escape((s.name || '') + ', code ' + (s.code || '')) + '">' +
          face +
          '<span class="cust-finish-dot__card cust-finish-dot__card--rich" aria-hidden="true">' +
            cardImg +
            '<span class="cust-finish-dot__card-body">' +
              '<span class="cust-finish-dot__card-eyebrow">Finish</span>' +
              '<span class="cust-finish-dot__card-name">' + escape(s.name) + '</span>' +
              '<span class="cust-finish-dot__card-divider" aria-hidden="true"></span>' +
              (s.desc ? '<span class="cust-finish-dot__card-desc">' + escape(s.desc) + '</span>' : '') +
              specRow('Texture', s.texture) +
              specRow('Material', s.material) +
              specRow('Code', s.code) +
            '</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
    // Collapsed by default to the first 3 rows (CSS hides the rest per
    // breakpoint); the toggle reveals the full field.
    return (
      '<div class="cust-finish-field" data-cust-finish-field>' + dots + '</div>' +
      '<button type="button" class="cust-finish-toggle" data-cust-finish-toggle aria-expanded="false">' +
        'Show all ' + swatches.length + ' finishes' +
      '</button>'
    );
  }

  // Feature-rows now render as accordions (A's 2026-06-05 direction).
  // First row (Integrated Lighting) is pre-expanded via `open` attribute.
  // Open/close animation uses CSS ::details-content (page.css) in modern Chrome/Edge.
  // Temperature/Kelvin groups (every item carries a color) render as one
  // continuous gradient pill bar with Kelvin ticks (Datch 2026-06-15), instead
  // of separate swatch chips. Full names are kept in the bar's aria-label.
  function renderGradientBar(sub, items) {
    var n = items.length;
    var stops = items.map(function (it, i) {
      var pct = n > 1 ? Math.round((i / (n - 1)) * 100) : 0;
      return escape(it.color) + ' ' + pct + '%';
    }).join(', ');
    var ticks = items.map(function (it) {
      var k = String(it.label).split('·').pop().trim();   // "Warm Glow . 2700K" -> "2700K"
      return '<li>' + escape(k) + '</li>';
    }).join('');
    // A color-filled circle node at each temperature point, sitting on the bar.
    var nodes = items.map(function (it) {
      return '<span class="cust-kelvin__node" style="background:' + escape(it.color) + ';"></span>';
    }).join('');
    var full = items.map(function (it) {
      return String(it.label).replace(/\s*·\s*/, ' ');
    }).join(', ');
    return (
      '<div class="cust-feat-row__sub">' +
        '<div class="cust-feat-row__sub-label">' + escape(sub.label) + '</div>' +
        '<div class="cust-kelvin" role="img" aria-label="' + escape(sub.label + ', warm to cool: ' + full) + '">' +
          '<div class="cust-kelvin__track">' +
            '<div class="cust-kelvin__bar" style="background:linear-gradient(90deg, ' + stops + ');"></div>' +
            '<div class="cust-kelvin__nodes" aria-hidden="true">' + nodes + '</div>' +
          '</div>' +
          '<ul class="cust-kelvin__ticks" aria-hidden="true">' + ticks + '</ul>' +
        '</div>' +
      '</div>'
    );
  }

  // One labeled chip list (label + wrapping chips). Shared by the accordion
  // groups (feature-rows) and the flat chip-groups format.
  function renderSubGroup(sub) {
    var items = sub.items || [];
    if (items.length && items.every(function (it) { return it && typeof it === 'object' && it.color; })) {
      return renderGradientBar(sub, items);
    }
    var itemsHtml = items.map(function (item) {
      // Item can be a plain string OR an object { label, color }.
      // If color provided, use it as the chip background (e.g. Kelvin light-color swatches).
      if (item && typeof item === 'object' && item.color) {
        return (
          '<li class="cust-feat-row__sub-item cust-feat-row__sub-item--swatch" style="background:' + escape(item.color) + ';">' +
            escape(item.label) +
          '</li>'
        );
      }
      var label = (item && typeof item === 'object') ? item.label : item;
      return '<li class="cust-feat-row__sub-item">' + escape(label) + '</li>';
    }).join('');
    return (
      '<div class="cust-feat-row__sub">' +
        '<div class="cust-feat-row__sub-label">' + escape(sub.label) + '</div>' +
        '<ul class="cust-feat-row__sub-list" aria-label="' + escape(sub.label) + '">' + itemsHtml + '</ul>' +
      '</div>'
    );
  }

  // Titled bullet-list columns with vertical dividers (Datch 2026-06-15), used
  // when a feature row sets subLayout:"columns" (e.g. Locks & Storage). Each
  // group is a column: Alata-caps title + a dotted bullet list.
  function renderSubColumns(subs) {
    var cols = (subs || []).map(function (g) {
      var items = (g.items || []).map(function (item) {
        var label = (item && typeof item === 'object') ? item.label : item;
        return '<li>' + escape(label) + '</li>';
      }).join('');
      return (
        '<div class="cust-feat-col">' +
          '<div class="cust-feat-col__title">' + escape(g.label) + '</div>' +
          '<ul class="cust-feat-col__list">' + items + '</ul>' +
        '</div>'
      );
    }).join('');
    // Only 4-group rows may go all-in-one-row (4-across); fewer groups stay
    // 2-col so they never leave empty columns.
    var wide = (subs || []).length === 4 ? ' cust-feat-cols--4up' : '';
    return '<div class="cust-feat-cols' + wide + '">' + cols + '</div>';
  }

  // Inline option icons (Datch 2026-06-16). Stroke glyphs in currentColor (navy
  // accent set in CSS); keyed by the row item's `icon` id. USB-A = squared plug
  // w/ contact tongue; USB-C = rounded pill plug; AC = North-American outlet
  // face (two slots + ground); wireless = bolt flanked by emanating waves.
  var FEATURE_ICONS = {
    'usb-a':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="7.5" y="2.5" width="9" height="13" rx="1"/>' +
        '<rect x="9.6" y="5" width="4.8" height="3.4" rx="0.4" fill="currentColor" stroke="none"/>' +
        '<path d="M12 15.5V21.5"/>' +
      '</svg>',
    'usb-c':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="6.5" y="2.5" width="11" height="9" rx="4.5"/>' +
        '<line x1="9.5" y1="7" x2="14.5" y2="7"/>' +
        '<path d="M12 11.5V21.5"/>' +
      '</svg>',
    'ac-na':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="3.5" y="4" width="17" height="16" rx="2.5"/>' +
        '<line x1="9.5" y1="8" x2="9.5" y2="12.5"/>' +
        '<line x1="14.5" y1="8" x2="14.5" y2="12.5"/>' +
        '<circle cx="12" cy="16" r="1.3" fill="currentColor" stroke="none"/>' +
      '</svg>',
    'wireless':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M6 8.5a5.5 5.5 0 0 0 0 7"/>' +
        '<path d="M18 8.5a5.5 5.5 0 0 1 0 7"/>' +
        '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10" fill="currentColor" stroke="none" transform="translate(6.6 6.6) scale(0.45)"/>' +
      '</svg>'
  };
  function renderIconGrid(items, heading) {
    var cells = (items || []).map(function (it) {
      var svg = FEATURE_ICONS[it.icon] || '';
      return (
        '<div class="cust-feat-icon">' +
          '<span class="cust-feat-icon__label">' + escape(it.label) + '</span>' +
          '<span class="cust-feat-icon__glyph">' + svg + '</span>' +
        '</div>'
      );
    }).join('');
    // Optional group header above the grid, styled like the column group-labels.
    var head = heading ? '<div class="cust-feat-col__title">' + escape(heading) + '</div>' : '';
    return '<div class="cust-feat-iconset">' + head + '<div class="cust-feat-icons">' + cells + '</div></div>';
  }

  function renderFeatureRowsBody(modal) {
    // Media keyed by row title, injected by Liquid (window.CUST_FEATURE_MEDIA).
    // Collapsed: small square thumbnail beside the title. Expanded: a larger
    // square image on the left, chip groups on the right (Datch 2026-06-15).
    // Rows with no media render a neutral placeholder square (images TBD).
    // r.desc holds a per-row conversion paragraph (Datch 2026-06-15), rendered
    // in the detail column above the chip groups.
    var media = window.CUST_FEATURE_MEDIA || {};
    var rowsHtml = (modal.rows || []).map(function (r, i) {
      var subHtml = r.subLayout === 'icons'
        ? renderIconGrid(r.sub || [], r.subHeading)
        : r.subLayout === 'columns'
          ? renderSubColumns(r.sub || [])
          : '<div class="cust-feat-row-acc__subs">' + (r.sub || []).map(renderSubGroup).join('') + '</div>';
      var openAttr = i === 0 ? ' open' : '';
      var m = media[r.title] || {};
      var thumb = m.thumb
        ? '<span class="cust-feat-row-acc__thumb" style="background-image:url(' + escape(m.thumb) + ')"></span>'
        : '<span class="cust-feat-row-acc__thumb cust-feat-row-acc__thumb--ph" aria-hidden="true"></span>';
      var bigImg = m.img
        ? '<img class="cust-feat-row-acc__img" src="' + escape(m.img) + '" loading="lazy" decoding="async" alt="">'
        : '<span class="cust-feat-row-acc__img cust-feat-row-acc__img--ph" aria-hidden="true"></span>';
      return (
        '<details class="cust-feat-row-acc"' + openAttr + '>' +
          '<summary>' +
            thumb +
            '<h4 class="cust-feat-row-acc__title">' + escape(r.title) + '</h4>' +
            '<svg class="cust-feat-row-acc__caret" width="18" height="18" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">' +
              '<path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/>' +
            '</svg>' +
          '</summary>' +
          '<div class="cust-feat-row-acc__body">' +
            '<div class="cust-feat-row-acc__media">' + bigImg + '</div>' +
            '<div class="cust-feat-row-acc__detail">' +
              (r.desc ? '<p class="cust-feat-row-acc__copy">' + escape(r.desc) + '</p>' : '') +
              subHtml +
            '</div>' +
          '</div>' +
        '</details>'
      );
    }).join('');
    return '<div class="cust-feat-rows-acc">' + rowsHtml + '</div>';
  }

  // Bullets — dot markers (per A 2026-06-05) + unified body typography
  // matching dim-table cells + accordion descs (Inter Tight 15px).
  function renderBulletsBody(modal) {
    var items = (modal.bullets || []).map(function (b) {
      return (
        '<li class="cust-bullet">' +
          '<span class="cust-bullet__dot" aria-hidden="true"></span>' +
          '<span class="cust-bullet__text">' + escape(b) + '</span>' +
        '</li>'
      );
    }).join('');
    return '<ul class="cust-bullets">' + items + '</ul>';
  }

  // Chip-groups — flat, always-open labeled chip lists (Branding row).
  // A single group set needs no accordion wrapper.
  function renderChipGroupsBody(modal) {
    var groupsHtml = (modal.groups || []).map(renderSubGroup).join('');
    return '<div class="cust-feat-chip-groups">' + groupsHtml + '</div>';
  }

  // Columns — titled bullet-list columns in the Locks & Storage style, but as a
  // top-level row body (e.g. Materials). renderSubColumns gives the .cust-feat-col
  // visual; the wrapper is its own query container so the columns go across when
  // the content column is wide.
  function renderColumnsBody(modal) {
    return '<div class="cust-cols-wrap">' + renderSubColumns(modal.groups || []) + '</div>';
  }

  // PANTONE color match (pms, 2026-10-17, board 8B): ten color columns, a light /
  // medium / dark square each. The squares are plain spans and open nothing; the
  // row's "Browse the colors" link (renderInline extras) opens the catalogue's
  // PANTONE pages. Colors are our own screen approximations.
  function renderPantoneColsBody(modal) {
    var cols = modal.cols || [];
    var names = cols.map(function (c) { return c.name; }).join(', ');
    var html = cols.map(function (c) {
      return (
        '<div class="cust-pms-col">' +
          ['l', 'm', 'd'].map(function (k) {
            return '<span class="cust-pms-col__sq" style="background:' + escape(c[k] || '#ccc') + ';"></span>';
          }).join('') +
          '<span class="cust-pms-col__name">' + escape(c.name) + '</span>' +
        '</div>'
      );
    }).join('');
    return '<div class="cust-pms-cols" role="img" aria-label="' + escape('Sample PANTONE colors, light to dark: ' + names) + '">' + html + '</div>';
  }

  function renderBody(modal) {
    switch (modal.format) {
      case 'ranges':       return renderRangesBody(modal);
      case 'swatches':     return renderSwatchesBody(modal);
      case 'feature-rows': return renderFeatureRowsBody(modal);
      case 'chip-groups':  return renderChipGroupsBody(modal);
      case 'columns':      return renderColumnsBody(modal);
      case 'pantone-cols': return renderPantoneColsBody(modal);
      default:             return renderBulletsBody(modal);
    }
  }

  function openExplainer(id) {
    var page = window.CustPage;
    var item = (page.data.features.items || []).find(function (it) { return it.id === id; });
    if (!item) return;
    var modal = item.modal || {};
    // For the finishes panel we drop body padding-top so the sticky filter bar
    // can sit flush with the scrollport's top (no 32px gap above it). The intro
    // paragraph carries its own padding-top to keep visual breathing room.
    var bodyClass = item.id === 'finishes' ? 'cust-modal__body cust-modal__body--sticky-top' : 'cust-modal__body';
    var introStyle = item.id === 'finishes'
      ? 'font-family: var(--ff-body); font-size: var(--fs-16); line-height: 1.6; color: var(--cust-text); margin: 0 0 24px; padding-top: 32px;'
      : 'font-family: var(--ff-body); font-size: var(--fs-16); line-height: 1.6; color: var(--cust-text); margin: 0 0 24px;';
    var html =
      '<div class="cust-modal__header">' +
        '<h2 class="cust-modal__h2"><span class="cust-logo-icon cust-logo-icon--md" style="color: var(--cust-primary);"></span>' + escape(modal.title) + '</h2>' +
      '</div>' +
      '<div class="' + bodyClass + '">' +
        '<p style="' + introStyle + '">' + escape(modal.intro) + '</p>' +
        renderBody(modal) +
      '</div>' +
      '<div class="cust-modal__footer' + (item.id === 'finishes' ? ' cust-modal__footer--split' : '') + '">' +
        (item.id === 'finishes'
          ? '<a class="cust-btn cust-btn--text" href="https://cdn.shopify.com/s/files/1/0600/0659/6668/files/Arc_Grove-Custom_Finishing_Selection_Guide.pdf" target="_blank" rel="noopener">Download Finish Catalogue<svg class="cust-feature-row__catalogue-arrow" width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 17L17 7M17 7H8M17 7V16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>'
          : '') +
        '<button class="cust-btn cust-btn--primary cust-btn--with-logo" data-cust-route-to="entry-selector">Start Your Custom Request</button>' +
      '</div>';
    page.modal.open(html);
  }

  function wire() {
    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-cust-feature-card]');
      if (card) {
        openExplainer(card.getAttribute('data-cust-feature-card'));
      }
      var routeBtn = e.target.closest('[data-cust-route-to="entry-selector"]');
      if (routeBtn && window.CustEntrySelector) {
        window.CustEntrySelector.open();
      }
      var toggle = e.target.closest('[data-cust-finish-toggle]');
      if (toggle) {
        var field = toggle.parentElement.querySelector('[data-cust-finish-field]');
        if (field) {
          var expanded = field.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          var total = field.querySelectorAll('.cust-finish-dot').length;
          toggle.textContent = expanded ? 'Show fewer finishes' : 'Show all ' + total + ' finishes';
        }
      }
    });
  }

  function init() {
    var page = window.CustPage;
    if (!page || !page.data || !page.data.features) return;
    renderInline(page.data.features.items || []);
    wire();
  }

  document.addEventListener('cust-page-ready', init);
})();


/* === scripts/process-swiper.js === */
/* =========================================================================
   process-swiper.js — Process section.
   Renders all 7 steps in one row + a horizontal timeline beneath that plots
   each step's cumulative timing label.
   (Name kept for cache continuity; this is no longer a swiper.)
   ========================================================================= */
(function () {
  'use strict';

  function escape(s) { return window.CustPage.escapeHtml(s); }

  function setGridColumns(gridEl, n, activeIdx) {
    var cols = [];
    for (var i = 0; i < n; i++) cols.push(i === activeIdx ? '4fr' : '1fr');
    gridEl.style.gridTemplateColumns = cols.join(' ');
  }

  function renderCards(items) {
    var gridEl = document.querySelector('[data-cust-process-grid]');
    if (!gridEl) return;
    var n = items.length;
    // Set fill duration as a CSS var so the track-fill knows how long to take.
    gridEl.style.setProperty('--fill-duration', (n * 110) + 'ms');
    setGridColumns(gridEl, n, 0); // first card starts expanded
    // First card starts expanded by default. Each card carries its own dot
    // anchored to the shared timeline track at the top of the card.
    gridEl.innerHTML = items.map(function (it, i) {
      var expandedCls = i === 0 ? ' is-expanded' : '';
      var dotDelay = i * 110 + 60;
      return (
        '<button class="cust-card cust-card--process' + expandedCls + '" data-cust-step="' + i + '" ' +
                'style="--step-delay: ' + (i * 110) + 'ms; --dot-delay: ' + dotDelay + 'ms" type="button" ' +
                'aria-expanded="' + (i === 0 ? 'true' : 'false') + '">' +
          '<span class="cust-card__dot"></span>' +
          (it.timing ? '<span class="cust-card__timing">' + escape(it.timing) + '</span>' : '') +
          '<h3 class="cust-card__title">' + escape(it.title) + '</h3>' +
          '<p class="cust-card__desc">' + escape(it.desc) + '</p>' +
        '</button>'
      );
    }).join('');
  }

  function wireExpand() {
    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-cust-step]');
      if (!card) return;
      var clickedIdx = parseInt(card.getAttribute('data-cust-step'), 10);
      var wasExpanded = card.classList.contains('is-expanded');
      // Single-active accordion — always one stays open.
      var activeIdx = wasExpanded ? 0 : clickedIdx;
      var cards = document.querySelectorAll('[data-cust-step]');
      cards.forEach(function (c) {
        var idx = parseInt(c.getAttribute('data-cust-step'), 10);
        var on = idx === activeIdx;
        c.classList.toggle('is-expanded', on);
        c.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      var gridEl = document.querySelector('[data-cust-process-grid]');
      if (gridEl) setGridColumns(gridEl, cards.length, activeIdx);
    });
  }

  function observeReveal() {
    var section = document.querySelector('.cust-process');
    if (!section || !('IntersectionObserver' in window)) {
      if (section) section.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          section.classList.add('is-revealed');
          io.disconnect();
        }
      });
    }, { threshold: 0.25 });
    io.observe(section);
  }

  function init() {
    var page = window.CustPage;
    if (!page || !page.data || !page.data.process) return;
    var items = page.data.process.items || [];
    if (!items.length) return;
    renderCards(items);
    wireExpand();
    observeReveal();
  }

  document.addEventListener('cust-page-ready', init);
})();


/* === scripts/case-study-modal.js === */
/* =========================================================================
   case-study-modal.js — Social proof section (rebuilt 2026-06-06 per A).
   - 3-card text-only featured grid (no hero photo)
       [business name] · [industry] · [city, state]
       [1-2 sentence description]              View more →
   - "Also built for" logo cards unchanged.
   - Click any case card → editorial modal:
       Products Customized (placeholder carousel)
       What we customized (1-2 sentence detail)
       Factory / Technical files (tabs; tabs only render when both have content)
   ========================================================================= */
(function () {
  'use strict';

  function renderGrid(featured) {
    var page = window.CustPage;
    var container = document.querySelector('[data-cust-cases-grid]');
    if (!container) return;
    container.innerHTML = featured.map(function (it, i) {
      var subhead = it.industry || '';   // location callout removed from the cards (Datch 2026-06-17)
      // Logo sits LEFT of the headers per A 2026-06-06. If no logo file is
      // present (e.g. Edge Safety has no fetchable favicon), fall back to a
      // text-based first-letter mark using the same brand pattern as the
      // "Also built for" logo cards.
      var initial = page.escapeHtml(((it.business || '').trim().charAt(0) || '·').toUpperCase());
      var logoHtml = it.logo
        ? '<div class="cust-card--text__logo"><img src="' + page.escapeHtml(it.logo) + '" alt="' + page.escapeHtml(it.business || '') + ' logo" loading="lazy"></div>'
        : '<div class="cust-card--text__logo cust-card--text__logo--text">' + initial + '</div>';
      var orderAttr = ' data-cust-order="' + page.escapeHtml(it.order || '') + '"';
      var logoStyleAttr = it.logo_style ? ' data-cust-logo-style="' + page.escapeHtml(it.logo_style) + '"' : '';
      return (
        '<button class="cust-card cust-card--text" data-cust-case-card="' + i + '"' + orderAttr + logoStyleAttr + '>' +
          '<div class="cust-card--text__head">' +
            logoHtml +
            '<div class="cust-card--text__head-text">' +
              '<h3 class="cust-card--text__title">' + page.escapeHtml(it.business || '') + '</h3>' +
              '<p class="cust-card--text__meta">' + page.escapeHtml(subhead) + '</p>' +
            '</div>' +
          '</div>' +
          '<p class="cust-card--text__desc">' + page.escapeHtml(it.description || '') + '</p>' +
          '<span class="cust-card--text__more">View project <span aria-hidden="true">&rarr;</span></span>' +
        '</button>'
      );
    }).join('');
  }

  function renderLogos(logos) {
    var page = window.CustPage;
    var container = document.querySelector('[data-cust-case-logos]');
    if (!container) return;
    container.innerHTML = logos.map(function (it) {
      var logoSlot = it.logo
        ? '<div class="cust-logo-card__mark"><img src="' + page.escapeHtml(it.logo) + '" alt="' + page.escapeHtml(it.business || '') + '" loading="lazy"></div>'
        : '<div class="cust-logo-card__mark cust-logo-card__mark--text">' + page.escapeHtml((it.business || '').toUpperCase()) + '</div>';
      return (
        '<div class="cust-logo-card">' +
          logoSlot +
          (it.sector ? '<div class="cust-logo-card__sector">' + page.escapeHtml(it.sector) + '</div>' : '') +
          (it.business ? '<div class="cust-logo-card__name">' + page.escapeHtml(it.business) + '</div>' : '') +
          '<div class="cust-logo-card__need">' + page.escapeHtml(it.need || '') + '</div>' +
        '</div>'
      );
    }).join('');
  }

  // ----------- Modal body sub-renderers -----------

  // Build the destination URL for a product card: `<absolute>/products/<handle>?customize=open&variant=<id>`
  // (A 2026-06-08). variant_id comes from case-studies.json. If missing,
  // fall back to ?customize=open (no variant pin).
  function buildProductUrl(p) {
    var handle = p.handle || '';
    var base = handle
      ? ('/products/' + handle)
      : (p.url || '#');
    if (!handle) return base;
    var qs = '?customize=open';
    if (p.variant_id) qs += '&variant=' + encodeURIComponent(p.variant_id);
    return base + qs;
  }

  // First word of the product title is the "Model Name" per A 2026-06-08.
  function modelNameOf(name) {
    return String(name || '').trim().split(/\s+/)[0] || '';
  }

  function renderProductsCarousel(products) {
    var page = window.CustPage;
    if (!products || !products.length) return '';
    var cards = products.map(function (p, i) {
      var img = p.image
        ? '<div class="cust-cv-product__img" style="background-image: url(\'' + page.escapeHtml(p.image) + '\');"></div>'
        : '<div class="cust-cv-product__img cust-cv-product__img--placeholder"></div>';
      var url = buildProductUrl(p);
      // Model Name is the first word of the product title.
      // Variant Name renders below as a subheading (A 2026-06-08).
      var model = modelNameOf(p.name);
      var variant = p.variant_title || '';
      var priceAttr = p.variant_id ? (' data-cust-variant-id="' + page.escapeHtml(String(p.variant_id)) + '"') : '';
      var initialPrice = p.price ? page.escapeHtml(p.price) : '';
      var variantHtml = variant
        ? '<div class="cust-cv-product__variant">' + page.escapeHtml(variant) + '</div>'
        : '';
      return (
        '<a class="cust-cv-product" href="' + page.escapeHtml(url) + '" target="_blank" rel="noopener">' +
          img +
          '<div class="cust-cv-product__body">' +
            '<div class="cust-cv-product__name">' + page.escapeHtml(model) + '</div>' +
            variantHtml +
            '<div class="cust-cv-product__price"' + priceAttr + '>' + initialPrice + '</div>' +
            '<span class="cust-cv-product__cta">' +
              'Customize This Design <span aria-hidden="true">&rarr;</span>' +
            '</span>' +
          '</div>' +
        '</a>'
      );
    }).join('');
    return (
      '<section class="cust-cv-section">' +
        '<h4 class="cust-cv-section__h">Products Customized</h4>' +
        '<div class="cust-cv-carousel" data-cust-cv-carousel>' +
          '<button type="button" class="cust-cv-carousel__arrow cust-cv-carousel__arrow--prev" data-cust-cv-prev aria-label="Previous" hidden>' +
            '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M165.66 202.34a8 8 0 0 1-11.32 11.32l-80-80a8 8 0 0 1 0-11.32l80-80a8 8 0 0 1 11.32 11.32L91.31 128Z"/></svg>' +
          '</button>' +
          '<div class="cust-cv-carousel__track" data-cust-cv-track>' + cards + '</div>' +
          '<button type="button" class="cust-cv-carousel__arrow cust-cv-carousel__arrow--next" data-cust-cv-next aria-label="Next">' +
            '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M181.66 133.66l-80 80a8 8 0 0 1-11.32-11.32L164.69 128 90.34 53.66a8 8 0 0 1 11.32-11.32l80 80A8 8 0 0 1 181.66 133.66Z"/></svg>' +
          '</button>' +
        '</div>' +
      '</section>'
    );
  }

  // ----- Live variant pricing via Storefront API -----
  // A 2026-06-08: "if the price was changed on the backend, that it must
  // change on the card as well." Fetch live amount + currencyCode for every
  // variant id rendered in the carousel and patch the .cust-cv-product__price.
  // The shared cust-page-data blob carries storefrontApi.endpoint + token
  // (populated by Liquid via shop.permanent_domain).
  function fetchLivePrices(variantIds) {
    var page = window.CustPage;
    var sf = (page && page.data && page.data.storefrontApi) || {};
    if (!sf.endpoint || !sf.token || !variantIds.length) return Promise.resolve({});
    var gids = variantIds.map(function (id) { return '"gid://shopify/ProductVariant/' + id + '"'; }).join(',');
    var query = '{ nodes(ids: [' + gids + ']) { ... on ProductVariant { id price { amount currencyCode } } } }';
    return fetch(sf.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sf.token },
      body: JSON.stringify({ query: query })
    }).then(function (r) {
      if (!r.ok) throw new Error('storefront HTTP ' + r.status);
      return r.json();
    }).then(function (json) {
      var out = {};
      (json && json.data && json.data.nodes || []).forEach(function (n) {
        if (!n || !n.id) return;
        var id = n.id.split('/').pop();
        out[id] = n.price;
      });
      return out;
    }).catch(function (e) { if (window.console) console.warn('[cust-cv] live price fetch failed', e); return {}; });
  }
  function formatMoney(p) {
    if (!p || !p.amount) return '';
    var amt = parseFloat(p.amount);
    // No decimals when .00 per brand rule (feedback_chain_zero...). Use US format for now.
    var rounded = (amt % 1 === 0) ? amt.toFixed(0) : amt.toFixed(2);
    var withCommas = rounded.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + withCommas;
  }
  function applyLivePrices(prices) {
    document.querySelectorAll('[data-cust-cv-track] [data-cust-variant-id]').forEach(function (el) {
      var id = el.getAttribute('data-cust-variant-id');
      var p = prices[id];
      if (p) {
        var label = formatMoney(p);
        if (label) el.textContent = label;
      }
    });
  }

  // ----- Carousel arrow edge-state -----
  // A 2026-06-08: hide left arrow at scroll start, hide right at scroll end.
  function updateCarouselArrows(track, prevBtn, nextBtn) {
    if (!track) return;
    var atStart = track.scrollLeft <= 1;
    var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    if (prevBtn) prevBtn.hidden = atStart;
    if (nextBtn) nextBtn.hidden = atEnd;
  }

  function renderWhatWeDid(text) {
    var page = window.CustPage;
    if (!text) return '';
    return (
      '<section class="cust-cv-section">' +
        '<h4 class="cust-cv-section__h">What we customized</h4>' +
        '<p class="cust-cv-body">' + page.escapeHtml(text) + '</p>' +
      '</section>'
    );
  }

  function renderMediaGrid(items) {
    var page = window.CustPage;
    if (!items.length) return '';
    return (
      '<div class="cust-cv-media-grid">' +
        items.map(function (it) {
          var thumb = it.url;
          var badge = it.type === 'pdf' ? 'PDF' : (it.type === 'video' ? 'VIDEO' : '');
          if (it.type === 'image') {
            return (
              '<a class="cust-cv-media" href="' + page.escapeHtml(it.url) + '" target="_blank" rel="noopener">' +
                '<img src="' + page.escapeHtml(thumb) + '" alt="' + page.escapeHtml(it.name || '') + '" loading="lazy">' +
              '</a>'
            );
          }
          return (
            '<a class="cust-cv-media cust-cv-media--file" href="' + page.escapeHtml(it.url) + '" target="_blank" rel="noopener" aria-label="' + page.escapeHtml(it.name || '') + '">' +
              '<div class="cust-cv-media__placeholder">' +
                (badge ? '<span class="cust-cv-media__badge">' + badge + '</span>' : '') +
                '<span class="cust-cv-media__name">' + page.escapeHtml(it.name || '') + '</span>' +
              '</div>' +
            '</a>'
          );
        }).join('') +
      '</div>'
    );
  }

  function renderFilesTabbed(factory, technical) {
    var page = window.CustPage;
    var hasFactory = factory && factory.length > 0;
    var hasTechnical = technical && technical.length > 0;
    if (!hasFactory && !hasTechnical) return '';

    // Both present → tabs; only one → single grid with section heading.
    if (hasFactory && hasTechnical) {
      return (
        '<section class="cust-cv-section">' +
          '<div class="cust-cv-tabs" role="tablist">' +
            '<button class="cust-cv-tab is-active" data-cust-cv-tab="factory" type="button" role="tab" aria-selected="true">Factory Photos <span class="cust-cv-tab__count">' + factory.length + '</span></button>' +
            '<button class="cust-cv-tab" data-cust-cv-tab="technical" type="button" role="tab" aria-selected="false">Technical Files <span class="cust-cv-tab__count">' + technical.length + '</span></button>' +
          '</div>' +
          '<div class="cust-cv-tab-panel" data-cust-cv-tab-panel>' +
            renderMediaGrid(factory) +
          '</div>' +
        '</section>'
      );
    }
    var soleBucket = hasFactory ? 'factory' : 'technical';
    var soleLabel  = hasFactory ? 'Factory Photos' : 'Technical Files';
    var soleItems  = hasFactory ? factory : technical;
    return (
      '<section class="cust-cv-section">' +
        '<h4 class="cust-cv-section__h">' + soleLabel + '</h4>' +
        renderMediaGrid(soleItems) +
      '</section>'
    );
  }

  // ----------- Modal opener -----------

  function openViewer(idx) {
    var page = window.CustPage;
    var it = (page.data['case-studies'].featured || [])[idx];
    if (!it) return;

    var loc = [it.city, it.state].filter(Boolean).join(', ');
    var subhead = [it.industry, loc].filter(Boolean).join(' · ');

    var html =
      '<div class="cust-case-viewer cust-case-viewer--editorial">' +
        // --- Editorial header (no hero photo) ---
        '<header class="cust-cv-head">' +
          '<h2 class="cust-cv-head__title">' + page.escapeHtml(it.business || '') + '</h2>' +
          (subhead ? '<p class="cust-cv-head__meta">' + page.escapeHtml(subhead) + '</p>' : '') +
        '</header>' +

        // --- Body sections (A 2026-06-09: What we customized first, products second) ---
        '<div class="cust-cv-body-wrap">' +
          renderWhatWeDid(it.what_we_customized) +
          renderProductsCarousel(it.products_customized) +
          renderFilesTabbed(it.factory || [], it.technical || []) +
        '</div>' +

        // --- Footer: Start a Similar Request (closes modal + scrolls to
        //     #how-it-works rotator section per A 2026-06-08). ---
        '<div class="cust-modal__footer">' +
          '<button class="cust-btn cust-btn--primary" data-cust-scroll-to-rotator>Start a Similar Request</button>' +
        '</div>' +
      '</div>';

    page.modal.open(html);

    // ----- Carousel arrow scroll + edge state -----
    var track = document.querySelector('[data-cust-cv-track]');
    var prevBtn = document.querySelector('[data-cust-cv-prev]');
    var nextBtn = document.querySelector('[data-cust-cv-next]');
    if (track) {
      function step(dir) {
        var amt = Math.round(track.clientWidth * 0.75) || 240;
        track.scrollBy({ left: dir * amt, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      // Initial + on-scroll edge update
      var raf = null;
      function refresh() {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          updateCarouselArrows(track, prevBtn, nextBtn);
        });
      }
      track.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      // After modal entrance animation settles, measure
      setTimeout(refresh, 50);
      setTimeout(refresh, 300);
    }

    // ----- Live variant prices (Storefront API by variant_id) -----
    var liveIds = (it.products_customized || []).map(function (p) { return p.variant_id; }).filter(Boolean);
    if (liveIds.length) {
      fetchLivePrices(liveIds).then(applyLivePrices);
    }

    // ----- "Start a Similar Request" → close modal + anchor jump to #how-it-works -----
    // A 2026-06-08: target is the rotator section (cust-section--rotator),
    // same animation as the hero "Start your request" anchor jump under
    // global html { scroll-behavior: smooth }.
    var simBtn = document.querySelector('[data-cust-scroll-to-rotator]');
    if (simBtn) {
      simBtn.addEventListener('click', function () {
        page.modal.close();
        setTimeout(function () {
          if (location.hash === '#how-it-works') location.hash = '';
          location.hash = '#how-it-works';
        }, 260);
      });
    }

    // ----- Tab switching (factory <-> technical) -----
    var panel = document.querySelector('[data-cust-cv-tab-panel]');
    if (panel) {
      document.querySelectorAll('[data-cust-cv-tab]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-cust-cv-tab');
          document.querySelectorAll('[data-cust-cv-tab]').forEach(function (o) {
            var on = o === b;
            o.classList.toggle('is-active', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          var items = (key === 'factory' ? (it.factory || []) : (it.technical || []));
          panel.innerHTML = renderMediaGrid(items);
        });
      });
    }
  }

  function wire() {
    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-cust-case-card]');
      if (card) {
        openViewer(parseInt(card.getAttribute('data-cust-case-card'), 10));
      }
    });
  }

  function init() {
    var page = window.CustPage;
    if (!page || !page.data || !page.data['case-studies']) return;
    var data = page.data['case-studies'];
    renderGrid(data.featured || []);
    renderLogos(data.logos || []);
    wire();
  }

  document.addEventListener('cust-page-ready', init);
})();


/* === scripts/entry-selector.js === */
/* =========================================================================
   entry-selector.js — Modal Type 1 (Entry Selector) + Type 2a (Product Picker)
                     + Type 2c (Scratch Furniture-Type Picker).
   - Opened from hero CTA + Main CTA buttons + feature-modal "Start" + case-viewer "Start similar".
   - "From Scratch" path → 4-tile furniture-type picker → click tile → window.LiveModal.open(bucket).
     No URL change, no reload. live-modal-bootstrap handles in-place injection and bucket switching.
   - "From Existing" path → product picker (filtered by category) → click product → opens a new tab
     to /products/<handle>?customize=open. The `?customize=open` query is the
     auto-open hook for the live v2.5 modal (URL sniffer required on the destination theme;
     if the sniffer isn't pushed, the modal won't auto-open and the user clicks the on-page card).
   ========================================================================= */
(function () {
  'use strict';

  // Furniture-type tiles for "Start from scratch". Bucket values mirror
  // snippets__customization-modal-data.liquid pt_bucket case-switch (live theme).
  // A 2026-06-08: simplified to clipart linedraw + furniture label only
  // (no eyebrow, no description). Images sourced from Shopify CDN.
  var SCRATCH_TILES = [
    { bucket: 'exec',  title: 'Executive Desk',     image: 'https://www.arcgrove.com/cdn/shop/files/Hershey-Right.webp?v=1777929171&width=522' },
    { bucket: 'conf',  title: 'Conference Table',   image: 'https://cdn.shopify.com/s/files/1/0600/0659/6668/files/hendley_linedraw.webp?v=1780971824' },
    { bucket: 'recep', title: 'Reception Desk',     image: 'https://www.arcgrove.com/cdn/shop/files/image_illyria_front_reception_desk_linedraw.webp?v=1777481732&width=800' },
    { bucket: 'shelf', title: 'Shelving & Storage', image: 'https://www.arcgrove.com/cdn/shop/files/image_core_mixed_media_office_shelves_st_linedraw.webp?v=1778185136&width=522' }
  ];

  function entrySelectorHtml() {
    return (
      '<div class="cust-modal__header" style="padding-top: 56px;">' +
        '<h2 class="cust-modal__h2"><span class="cust-logo-icon cust-logo-icon--md" style="color: var(--cust-primary);"></span>How would you like to start?</h2>' +
        '<p class="cust-modal__helper">Pick a starting point. We\'ll guide you through dimensions, finishes, and features.</p>' +
      '</div>' +
      '<div class="cust-modal__body">' +
        '<div class="cust-tile-grid">' +
          '<button class="cust-tile" data-cust-entry-pick="existing">' +
            '<span class="cust-tile__eyebrow">Option 01</span>' +
            '<h3 class="cust-tile__title">From an existing design</h3>' +
            '<p class="cust-tile__sub">Browse our common builds — Executive Desks, Conference Tables, Reception, Shelving. We\'ll customize from a tested starting point.</p>' +
          '</button>' +
          '<button class="cust-tile" data-cust-entry-pick="scratch">' +
            '<span class="cust-tile__eyebrow">Option 02</span>' +
            '<h3 class="cust-tile__title">From scratch</h3>' +
            '<p class="cust-tile__sub">Pick a category, set your exact dimensions and finishes. Engineering builds your concept from a blank sheet.</p>' +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function productPickerHtml() {
    var page = window.CustPage;
    var products = (page.data['wizard-sample-data'].products || []);
    var categories = (page.data['wizard-sample-data'].categories || []);
    var esc = page.escapeHtml;
    // Toolbar: free-text search + category <select> (Datch 2026-06-18). Replaces the
    // old pill row — condenses the categories into a dropdown with "All" default.
    var filterHtml =
      '<div class="cust-picker-toolbar" data-cust-picker-toolbar>' +
        '<button type="button" class="cust-picker-search-toggle" data-cust-picker-search-toggle aria-label="Search models" aria-expanded="false">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>' +
        '</button>' +
        '<div class="cust-picker-search">' +
          '<svg class="cust-picker-search__icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>' +
          '<input type="search" class="cust-picker-search__input" data-cust-picker-search placeholder="Search models" aria-label="Search the catalog" autocomplete="off" />' +
        '</div>' +
        '<select class="cust-picker-select" data-cust-picker-select aria-label="Filter by category">' +
          '<option value="all">All types</option>' +
          categories.map(function (c) { return '<option value="' + esc(c.id) + '">' + esc(c.name) + '</option>'; }).join('') +
        '</select>' +
      '</div>';
    var gridHtml =
      '<div class="cust-picker-grid" data-cust-picker-grid>' +
        products.map(function (p) {
          // Model name: prefer a real metafield value (p.model) if the data ever carries
          // one; otherwise derive from the "<Model> &middot; <Type>" name prefix (verified
          // clean single-word model names across all sample products). Datch 2026-06-18.
          var model = p.model || (p.name.split('·')[0] || p.name).trim();
          var imgInner = p.image
            ? '<img src="' + esc(p.image) + '" alt="' + esc(p.name) + '" loading="lazy" />'
            : '';
          var mediaClass = p.image ? 'cust-card__media' : 'cust-card__media cust-card__media--placeholder';
          return (
            '<button class="cust-card cust-card--picker" data-cust-pick-product="' + esc(p.id) + '" data-cust-product-category="' + esc(p.category) + '" data-cust-search="' + esc((model + ' ' + p.name).toLowerCase()) + '">' +
              '<div class="' + mediaClass + '">' +
                imgInner +
                '<span class="cust-card__model-tag">' + esc(model) + '</span>' +
              '</div>' +
            '</button>'
          );
        }).join('') +
      '</div>' +
      '<p class="cust-picker-empty" data-cust-picker-empty hidden>No models match your search.</p>';
    return (
      '<div class="cust-modal__header cust-modal__header--navy">' +
        '<h2 class="cust-modal__h2">' +
          '<svg class="cust-modal__h2-icon" viewBox="0 0 720 720" fill="none" stroke="currentColor" stroke-width="50" stroke-miterlimit="10" aria-hidden="true">' +
            '<polygon points="138.9 83.75 138.9 589.78 639.67 583.21 138.9 83.75"></polygon>' +
            '<polygon points="224.33 283.53 224.33 512.23 455.66 512.23 224.33 283.53"></polygon>' +
            '<line x1="245.36" y1="251.99" x2="277.08" y2="221.58"></line>' +
            '<line x1="300.56" y1="305.88" x2="331.04" y2="275.39"></line>' +
            '<line x1="359.71" y1="355.35" x2="385" y2="329.21"></line>' +
            '<line x1="417.54" y1="407.08" x2="438.31" y2="382.38"></line>' +
            '<line x1="474.06" y1="463.6" x2="495.55" y2="439.47"></line>' +
            '<line x1="530.58" y1="512.23" x2="550.83" y2="494.6"></line>' +
          '</svg>' +
          'Choose a model design to customize' +
        '</h2>' +
        '<p class="cust-modal__helper">We\'ll route you to that product\'s page and open the customization wizard with sensible defaults.</p>' +
        filterHtml +
      '</div>' +
      '<div class="cust-modal__body cust-modal__body--picker">' +
        gridHtml +
      '</div>'
    );
  }

  function scratchPickerHtml() {
    var page = window.CustPage;
    return (
      // Logo icon removed per A 2026-06-08. Heading aligns flush-left with the
      // helper paragraph below it (no inline padding-top override needed —
      // .cust-modal__header already has the correct vertical padding).
      '<div class="cust-modal__header">' +
        '<h2 class="cust-modal__h2">' +
          '<svg class="cust-modal__h2-icon" viewBox="0 0 720 720" fill="none" stroke="currentColor" stroke-width="50" stroke-miterlimit="10" aria-hidden="true">' +
            '<polygon points="138.9 83.75 138.9 589.78 639.67 583.21 138.9 83.75"></polygon>' +
            '<polygon points="224.33 283.53 224.33 512.23 455.66 512.23 224.33 283.53"></polygon>' +
            '<line x1="245.36" y1="251.99" x2="277.08" y2="221.58"></line>' +
            '<line x1="300.56" y1="305.88" x2="331.04" y2="275.39"></line>' +
            '<line x1="359.71" y1="355.35" x2="385" y2="329.21"></line>' +
            '<line x1="417.54" y1="407.08" x2="438.31" y2="382.38"></line>' +
            '<line x1="474.06" y1="463.6" x2="495.55" y2="439.47"></line>' +
            '<line x1="530.58" y1="512.23" x2="550.83" y2="494.6"></line>' +
          '</svg>' +
          'Pick a furniture type' +
        '</h2>' +
        '<p class="cust-modal__helper">We\'ll customize from a representative model. Dimensions, finishes, and features adjust in the next steps.</p>' +
      '</div>' +
      '<div class="cust-modal__body">' +
        '<div class="cust-tile-grid cust-tile-grid--art">' +
          SCRATCH_TILES.map(function (t) {
            return (
              '<button class="cust-tile cust-tile--art" data-cust-scratch-pick="' + page.escapeHtml(t.bucket) + '">' +
                '<div class="cust-tile__art">' +
                  '<img src="' + page.escapeHtml(t.image) + '" alt="" loading="lazy" decoding="async">' +
                '</div>' +
                '<h3 class="cust-tile__title">' + page.escapeHtml(t.title) + '</h3>' +
              '</button>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function openEntrySelector() {
    var page = window.CustPage;
    page.modal.open(entrySelectorHtml());
  }

  function openScratchPicker() {
    var page = window.CustPage;
    page.modal.push(scratchPickerHtml());
    document.querySelectorAll('[data-cust-scratch-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bucket = btn.getAttribute('data-cust-scratch-pick');
        if (!bucket) return;
        // Close the picker, then call LiveModal.open(bucket) in-place.
        // Per A 2026-06-06: no full page reload on tile click — modal
        // opens on top of the current landing without losing scroll
        // position. live-modal-bootstrap.js handles the injection.
        if (window.CustPage && window.CustPage.modal) window.CustPage.modal.close();
        if (window.LiveModal && typeof window.LiveModal.open === 'function') {
          setTimeout(function () { window.LiveModal.open(bucket); }, 280);
        }
      });
    });
  }

  function openPicker() {
    var page = window.CustPage;
    page.modal.push(productPickerHtml());
    // Wire search + category filter (combined: a card shows only if it matches BOTH).
    var grid = document.querySelector('[data-cust-picker-grid]');
    var searchInput = document.querySelector('[data-cust-picker-search]');
    var select = document.querySelector('[data-cust-picker-select]');
    var emptyMsg = document.querySelector('[data-cust-picker-empty]');
    var pickerCards = grid ? grid.querySelectorAll('[data-cust-pick-product]') : [];
    function applyPickerFilters() {
      var cat = select ? select.value : 'all';
      var q = (searchInput ? searchInput.value : '').trim().toLowerCase();
      var shown = 0;
      pickerCards.forEach(function (c) {
        var okCat = (cat === 'all') || (c.getAttribute('data-cust-product-category') === cat);
        var okQ = !q || (c.getAttribute('data-cust-search') || '').indexOf(q) >= 0;
        var show = okCat && okQ;
        c.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      if (emptyMsg) emptyMsg.hidden = shown !== 0;
    }
    if (select) select.addEventListener('change', applyPickerFilters);
    if (searchInput) searchInput.addEventListener('input', applyPickerFilters);
    // Mobile: the search collapses to a magnifier toggle; tapping it expands the full input +
    // focuses. Blur-when-empty re-collapses so the compact [magnifier][select] row returns.
    var pickerToolbar = document.querySelector('[data-cust-picker-toolbar]');
    var searchToggle = document.querySelector('[data-cust-picker-search-toggle]');
    if (searchToggle && pickerToolbar) {
      searchToggle.addEventListener('click', function () {
        pickerToolbar.classList.add('is-search-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        if (searchInput) searchInput.focus();
      });
    }
    if (searchInput && pickerToolbar) {
      searchInput.addEventListener('blur', function () {
        if (!searchInput.value.trim()) {
          pickerToolbar.classList.remove('is-search-open');
          if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
    grid.querySelectorAll('[data-cust-pick-product]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var productId = tile.getAttribute('data-cust-pick-product');
        if (!productId) return;
        // Root-relative so the new tab opens on the live host. ?customize=open
        // auto-opens the customization modal on the PDP. (2026-10-07: the old
        // preview_theme_id pin pointed at v2.65, which no longer exists, so
        // every pick landed on a "Theme cannot be previewed" error.)
        var url = '/products/' + productId + '?customize=open';
        window.open(url, '_blank', 'noopener');
        // Close the picker so the user returns to a clean landing when
        // they switch back from the new tab.
        if (window.CustPage && window.CustPage.modal) window.CustPage.modal.close();
      });
    });
  }

  function wire() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cust-trigger="entry-selector"]');
      if (trigger) {
        var path = trigger.getAttribute('data-cust-entry-path');
        if (path === 'scratch') {
          openScratchPicker();
        } else if (path === 'existing') {
          openEntrySelector();
          // Auto-advance straight into picker since path is pre-chosen
          setTimeout(openPicker, 50);
        } else {
          openEntrySelector();
        }
        return;
      }
      var pick = e.target.closest('[data-cust-entry-pick]');
      if (pick) {
        var p = pick.getAttribute('data-cust-entry-pick');
        if (p === 'existing') openPicker();
        else if (p === 'scratch') openScratchPicker();
      }
    });
  }

  function init() {
    if (!window.CustPage) return;
    wire();
    window.CustEntrySelector = {
      open: openEntrySelector,
      openPicker: openPicker,
      openScratchPicker: openScratchPicker
    };
  }

  document.addEventListener('cust-page-ready', init);
})();


/* === scripts/live-modal-bootstrap.js === */
/* =========================================================================
   live-modal-bootstrap.js
   --------------------------------------------------------------
   Embeds the EXACT live v2.5 customization modal locally and opens it in-place
   for the "Start from scratch" flow. Exposes `window.LiveModal.open(bucket)`
   for programmatic invocation (entry-selector.js calls this on tile click).

   Asset sources (generated by .tmp/render_live_modal.py from cached live
   theme bytes; never edit by hand):
     assets/live-modal/customization-modal.css
     assets/live-modal/customization-modal.js
     assets/live-modal/modal-markup.html
     assets/live-modal/modal-data-<bucket>.json   (exec | conf | recep | shelf)

   Bucket switching without page reload (per A 2026-06-06):
     - First open this session  → fetch + inject + run JS + PDPCV.open()
     - Same-bucket reopen       → window.PDPCV.open() (no re-injection)
     - Different-bucket reopen  → teardown previous instance (remove modal DOM,
                                  blob <script>, JS <script>, window.PDPCV),
                                  then inject fresh against new bucket's blob

   The live JS's IIFE captures `data` in closure on script-tag execution; the
   only way to feed it a different blob without modifying the JS itself
   (forbidden by A's "EXACT" rule) is to remove the script tag, reset the
   closure-bearing global (window.PDPCV), and re-load the script with a cache
   buster so the IIFE re-runs against the new <script id="pdpcv-modal-data">.
   Old window-level listeners from the previous IIFE remain attached but
   their queries hit a stale (now-removed) DOM and silently no-op.
   ========================================================================= */
(function () {
  'use strict';

  var VALID_BUCKETS = ['exec', 'conf', 'recep', 'shelf'];
  var ASSET_BASE = (window.CUST_LIVE_MODAL_ASSET_BASE) || './assets/live-modal/';
  var JS_SRC = ASSET_BASE + 'customization-modal.js';
  var currentBucket = null;
  var busy = false;

  function loadCss(href) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('link[data-live-modal-css]')) return resolve();
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.setAttribute('data-live-modal-css', '1');
      l.onload = function () { resolve(); };
      l.onerror = function () { reject(new Error('css load failed: ' + href)); };
      document.head.appendChild(l);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.setAttribute('data-live-modal-js', '1');
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('script load failed: ' + src)); };
      document.body.appendChild(s);
    });
  }

  function waitForPDPCV(maxMs) {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      (function poll() {
        if (window.PDPCV && typeof window.PDPCV.open === 'function') return resolve();
        if (Date.now() - start > maxMs) return reject(new Error('window.PDPCV did not register in ' + maxMs + 'ms'));
        setTimeout(poll, 30);
      })();
    });
  }

  function teardown() {
    // Close currently-open modal so the body class + scroll lock get released.
    try {
      if (window.PDPCV && typeof window.PDPCV.close === 'function') {
        window.PDPCV.close();
      }
    } catch (e) { /* ignore */ }
    // Remove modal DOM (data-pdpcv-root is the wrapper that holds backdrop + modal + lightbox).
    document.querySelectorAll('[data-pdpcv-root]').forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
    // Remove the inline JSON blob.
    var blob = document.getElementById('pdpcv-modal-data');
    if (blob && blob.parentNode) blob.parentNode.removeChild(blob);
    // Remove the live JS <script> tag (so the IIFE will re-run when we re-add it with a cache buster).
    document.querySelectorAll('script[data-live-modal-js]').forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
    // Drop the global so waitForPDPCV() doesn't resolve against the previous instance.
    try { delete window.PDPCV; } catch (e) { window.PDPCV = undefined; }
  }

  function injectAndOpen(bucket) {
    busy = true;
    // A 2026-06-09: flag the customization-modal.js's buildHeadingTitle patch
    // to use copy.step1Heading ('Customize Your <Furniture Type>') instead of
    // the verbatim live behaviour ('Customize the <FirstWord> design').
    // Only set on this scratch path — PDPs leave window.CUST_SCRATCH_FLOW unset
    // so they keep the original heading exactly.
    window.CUST_SCRATCH_FLOW = true;
    Promise.all([
      fetch(window.CUST_LIVE_MODAL_MARKUP_URL || (ASSET_BASE + 'cust-modal-markup.html')).then(function (r) {
        if (!r.ok) throw new Error('markup fetch ' + r.status);
        return r.text();
      }),
      fetch((window.CUST_LIVE_MODAL_DATA_URLS && window.CUST_LIVE_MODAL_DATA_URLS[bucket]) || (ASSET_BASE + 'cust-modal-data-' + bucket + '.json')).then(function (r) {
        if (!r.ok) throw new Error('blob fetch ' + r.status);
        return r.text();
      })
    ]).then(function (parts) {
      return loadCss((window.CUST_LIVE_MODAL_CSS_URL) || (ASSET_BASE + 'customization-modal.css')).then(function () {
        // Inject the [data-pdpcv-root] markup (hidden until JS opens it).
        document.body.insertAdjacentHTML('beforeend', parts[0]);

        // Inject the JSON blob with the id the live JS expects.
        var s = document.createElement('script');
        s.type = 'application/json';
        s.id = 'pdpcv-modal-data';
        s.textContent = parts[1];
        document.body.appendChild(s);

        // Cache buster so subsequent (different-bucket) injections re-fetch
        // and re-evaluate the IIFE rather than no-op against a cached body.
        return loadScript((window.CUST_LIVE_MODAL_JS_URL || JS_SRC) + '?b=' + bucket + '&t=' + Date.now());
      });
    }).then(function () {
      return waitForPDPCV(2000);
    }).then(function () {
      currentBucket = bucket;
      busy = false;
      window.PDPCV.open();
    }).catch(function (e) {
      busy = false;
      if (window.console) console.error('[live-modal-bootstrap] inject failed:', e);
    });
  }

  function open(bucket) {
    if (VALID_BUCKETS.indexOf(bucket) < 0) return;
    if (busy) return;

    // Same bucket already loaded → just reopen the existing modal.
    if (currentBucket === bucket && window.PDPCV) {
      window.PDPCV.open();
      return;
    }

    // Different bucket while already initialized → teardown the previous
    // instance + reinject against the new blob. Verbatim live JS is preserved;
    // only the surrounding DOM + globals get cycled.
    if (currentBucket) {
      teardown();
    }

    injectAndOpen(bucket);
  }

  window.LiveModal = {
    open: open,
    get bucket() { return currentBucket; }
  };
})();


/* === finish hover-card edge clamp === */
/* The rich finish card is centered above its swatch dot. For dots near the left/right
   viewport edge the centered 340px card would overflow; on first hover/focus we measure
   it and re-anchor (is-shift-left/right, styled in customization-page.css). Delegated so
   it covers all 158 dots regardless of when the field expands. (Datch 2026-06-26) */
(function () {
  'use strict';
  function clamp(e) {
    var t = e.target;
    var dot = t && t.closest ? t.closest('.cust-finish-dot') : null;
    if (!dot) return;
    var card = dot.querySelector('.cust-finish-dot__card');
    if (!card) return;
    card.classList.remove('is-shift-left', 'is-shift-right');
    var r = card.getBoundingClientRect();            // valid even while visibility:hidden
    var vw = document.documentElement.clientWidth;
    if (r.right > vw - 8) card.classList.add('is-shift-left');
    else if (r.left < 8) card.classList.add('is-shift-right');
  }
  document.addEventListener('pointerover', clamp, true);
  document.addEventListener('focusin', clamp, true);
})();

/* agfsh:start */
/* agfsh r2 - customization finishes: mobile tap opens a bottom sheet clone of
   the dot's hover card, PDP finish-sheet register (2026-08-07). Close X = the
   PDP sheet's own Phosphor glyph (finishing-display.js SHEET_CLOSE_SVG).
   Overlay: theme-test/cust-finish-sheet/. */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  if (!mq) return;
  var CLOSE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" focusable="false" aria-hidden="true"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>';
  /* r3: per-tone use-case sentences - VERBATIM from the PDP's authored-once
     snippets/finish-usecase.liquid (the two surfaces must not diverge). */
  var USECASE = {
    light: 'Bright, airy. Best for open offices, smaller spaces, and environments that need to feel brighter.',
    medium: 'Works in most office settings. Good for shared spaces and general use.',
    dark: 'Great for executive offices and spaces where a more formal look is needed.'
  };
  var toneByCode = null;
  function loadTones() {
    if (toneByCode) return toneByCode;
    toneByCode = {};
    try {
      var el = document.getElementById('cust-page-data');
      if (!el) return toneByCode;
      var found = null;
      (function walk(node) {
        if (found || node == null) return;
        if (Object.prototype.toString.call(node) === '[object Array]') {
          if (node.length && node[0] && typeof node[0] === 'object'
              && 'code' in node[0] && 'tone' in node[0]) { found = node; return; }
          for (var i = 0; i < node.length; i++) walk(node[i]);
        } else if (typeof node === 'object') {
          for (var k in node) walk(node[k]);
        }
      })(JSON.parse(el.textContent));
      if (found) for (var j = 0; j < found.length; j++) {
        if (found[j].code) toneByCode[found[j].code] = String(found[j].tone || '');
      }
    } catch (err) { /* no blob -> no pill; sheet still works */ }
    return toneByCode;
  }
  function cardCode(card) {
    var specs = card.querySelectorAll('.cust-finish-dot__card-spec');
    for (var i = 0; i < specs.length; i++) {
      var lab = specs[i].querySelector('.cust-finish-dot__card-label');
      var val = specs[i].querySelector('.cust-finish-dot__card-val');
      if (lab && val && lab.textContent.replace(/\s/g, '') === 'Code') {
        return val.textContent.replace(/^\s+|\s+$/g, '');
      }
    }
    return '';
  }
  function injectToneRow(clone, srcCard) {
    var tone = (loadTones()[cardCode(srcCard)] || '').toLowerCase();
    if (!USECASE[tone]) return;
    var row = document.createElement('span');
    row.className = 'agfsh-tone-row';
    row.innerHTML = '<span class="agfsh-pill">' + tone.toUpperCase() + ' TONE</span>'
      + '<span class="agfsh-usecase">' + USECASE[tone] + '</span>';
    var divider = clone.querySelector('.cust-finish-dot__card-divider');
    var cardBody = clone.querySelector('.cust-finish-dot__card-body');
    if (divider && divider.parentNode) divider.parentNode.insertBefore(row, divider.nextSibling);
    else if (cardBody) cardBody.appendChild(row);
  }
  var wrap = null, body = null;
  function close() {
    if (wrap) wrap.classList.remove('is-open');
    document.documentElement.classList.remove('agfsh-lock');
  }
  function ensure() {
    if (wrap) return;
    wrap = document.createElement('div');
    wrap.className = 'agfsh-backdrop';
    wrap.innerHTML = '<div class="agfsh-sheet" role="dialog" aria-modal="true" aria-label="Finish details">'
      + '<button type="button" class="agfsh-close" aria-label="Close">' + CLOSE_SVG + '</button>'
      + '<div class="agfsh-body"></div></div>';
    document.body.appendChild(wrap);
    body = wrap.querySelector('.agfsh-body');
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    wrap.querySelector('.agfsh-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var dot = e.target && e.target.closest ? e.target.closest('.cust-finish-dot') : null;
    if (!dot) return;
    var card = dot.querySelector('.cust-finish-dot__card');
    if (!card) return;
    e.preventDefault();
    ensure();
    body.innerHTML = '';
    var clone = card.cloneNode(true);
    clone.classList.remove('is-shift-left', 'is-shift-right');
    clone.removeAttribute('aria-hidden');
    injectToneRow(clone, card);
    body.appendChild(clone);
    wrap.classList.add('is-open');
    document.documentElement.classList.add('agfsh-lock');
  }, true);
})();
/* agfsh:end */
